<div
    class="d-flex flex-column justify-content-center align-items-center h-100 w-100"
>
    <div
        class="spinner-border"
        [ngStyle]="{ width: size(), height: size() }"
        role="status"
    ></div>
</div>
